import { useNavigate } from 'react-router';
import { MdOutlineLogout } from 'react-icons/md';
import { HiCog } from 'react-icons/hi';
import { useAuth } from '~/contexts/AuthContext';
import { clearSession } from '~/lib/session';

interface ProfileDropdownProps {
  collapsed: boolean;
  onOpenSettings: () => void;
}

export default function ProfileDropdown({ collapsed, onOpenSettings }: ProfileDropdownProps) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearSession();
    navigate('/');
    window.location.reload();
  };

  return (
    <div
      className={`dropdown dropdown-top w-full ${
        collapsed ? 'dropdown-right' : 'dropdown-center'
      }`}
    >
      {/* Profile Card Trigger */}
      <div
        tabIndex={0}
        role="button"
        className={`w-full p-2 hover:bg-base-300 transition-colors rounded-lg flex items-center gap-3 ${
          collapsed ? 'justify-center' : ''
        }`}
      >
        {/* Avatar */}
        <div className="avatar">
          <div className="w-8 h-8 rounded-lg">
            <div className="w-full h-full bg-base-100 flex items-center justify-center rounded-lg text-sm font-semibold">
              {user?.email?.[0]?.toUpperCase() || 'U'}
            </div>
          </div>
        </div>
        {/* Email (only when not collapsed) */}
        {!collapsed && (
          <span className="text-sm font-medium truncate flex-1 text-left">
            {user?.email}
          </span>
        )}
      </div>

      {/* Profile Dropdown Content */}
      <div
        tabIndex={0}
        className="dropdown-content card card-compact bg-base-100 z-[1] w-64 shadow-lg"
      >
        <div className="card-body p-2">
          {/* Settings */}
          <button
            onClick={onOpenSettings}
            className="flex items-center gap-3 w-full p-2 hover:bg-base-300 rounded"
          >
            <HiCog size={16} />
            <span>Settings</span>
          </button>

          {/* Logout */}
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 w-full p-2 hover:bg-base-300 rounded"
          >
            <MdOutlineLogout size={16} />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
}
